import {DataGrid} from "@mui/x-data-grid";
import {useContext, useEffect, useState} from "react";
import {
    Box,
    Button, ButtonGroup,
    Card,
    CardHeader, Chip,
    Container,
    Divider, FormControl,
    Grid, InputLabel, Link,
    MenuItem,
    Modal, OutlinedInput, Select,
    TextField,
    Typography
} from "@mui/material";
import axios from "axios";
import {useTheme} from "@mui/material/styles";
import { useAuthState } from 'react-firebase-hooks/auth';

import {TableMoreMenu} from "../../components/table";
import Page from "../../components/Page";
import LoadingBackdrop from "../../components/LoadingBackdrop";
import Iconify from "../../components/Iconify";
import useSettings from "../../hooks/useSettings";
import {BASE_HOST, getAccountAPIHeader} from "../../utils/urlConst";
import {DateRangeContext} from "./DateProvider";
import { auth } from '../../firebase';

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -25%)',
    // width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};


export default function Placements() {
    const [user] = useAuthState(auth);

    const {themeStretch} = useSettings();
    const theme = useTheme();
    const dateSelectorState = useContext(DateRangeContext);
    const [lists, setLists] = useState([]);
    const [loadingLists, setLoadingLists] = useState(true);
    const [offersBreakdown, setOfferBreakdown] = useState(false);
    const [openMenu, setOpenMenuActions] = useState(null);
    const [selectedPlacement, setSelectedPlacement] = useState(null);

    const [advertisers, setAdvertisers] = useState([]);
    const [offers, setOffers] = useState([]);
    const [ads, setAds] = useState([]);


    // Filter Out Offers based on...

    const handleCloseMenu = () => {
        setOpenMenuActions(null);
    };

    function generateActionMenuForRow(row) {
        return <>
            <MenuItem
                key={"edit-placement"}
                onClick={() => {

                    setSelectedPlacement(row);
                }}
            >
                <Iconify icon={'eva:edit-2-outline'}/>
                <p>Edit</p>
            </MenuItem>
        </>
    }

    const columns = [
        {field: 'id', headerName: "id",  minWidth: 120, hide: false},
        {field: 'name', headerName: "Placement Name", flex: 1, minWidth: 120},
        {field: 'sent', headerName: "Sent",  minWidth: 120},
        {field: 'open', headerName: "Open Rate", minWidth: 120},
        {field: 'rpm', headerName: "RPM", minWidth: 120},
        {
            field: "actions",
            headerName: "Actions",
            width: 75,
            renderCell: (params) => {
                return <TableMoreMenu
                    open={(openMenu != null && openMenu.id === params.row.id) ? openMenu.bind : null}
                    onOpen={(event) => setOpenMenuActions({id: params.row.id, bind: event.currentTarget})}
                    onClose={handleCloseMenu}
                    actions={generateActionMenuForRow(params.row)}
                />
            }

        }
    ];

    useEffect(() => {
        user.getIdToken().then((idToken) => {
            if (advertisers.length === 0) {
                axios.get(`${BASE_HOST}/api/basic/placement-tools`, getAccountAPIHeader(idToken))
                  .then(res => {
                      setAdvertisers(res.data.advertisers);
                      setOffers(res.data.offers);
                      setAds(res.data.adMapping);
                      setLoadingLists(false)
                  })
            }
            axios.get(`${BASE_HOST}/api/basic/placements?startDate=${dateSelectorState.dates[0].toISOString().substring(0, 10)}&endDate=${dateSelectorState.dates[1].toISOString().substring(0, 10)}`, getAccountAPIHeader(idToken))
              .then(res => {
                  // setAdvertisers(res.data.advertisers);
                  setLists(res.data);
              })
        })

    }, [dateSelectorState.dates])


    const offerMapping = {}
    // eslint-disable-next-line no-restricted-syntax
    for (const offer of offers) {
        offerMapping[offer.id] = offer;
    }

    let adStats = 0;
    let matchedOffers = 0;
    const relevantOfferOptions = [];
    const relevantAdvertiserOptions = new Set();

    const selectedOffers = [];
    const offerMap = {};
    offers.forEach(v=>{
        offerMap[v._id] = v;
    })

    if (selectedPlacement) {
        console.log("look! listen!")

        // eslint-disable-next-line no-restricted-syntax
        for (const offer of offers) {
            if (
                (selectedPlacement.type === "any" || offer.type === selectedPlacement.type)&&
                !selectedPlacement?.excludedOffers?.includes(offer._id)
            ) {
                relevantAdvertiserOptions.add(offer.advertiser);
                if((selectedPlacement.advertisers.indexOf("any") !== -1 || selectedPlacement.advertisers.indexOf(offer.advertiser) !== -1)){
                    relevantOfferOptions.push(offer);
                }
            }
        }



        const restrictOffers = selectedPlacement.offers.indexOf("any") !== -1;
        // eslint-disable-next-line no-restricted-syntax
        for (const offer of offers) {
            console.log("look! Listen?1123")
            if ((selectedPlacement.advertisers.indexOf("any") !== -1 || selectedPlacement.advertisers.indexOf(offer.advertiser) !== -1)
                && (selectedPlacement.type === "any" || offer.type === selectedPlacement.type)
                && (restrictOffers || selectedPlacement.offers.indexOf(offer._id) !== -1)
                && (offer.ads > 0)
                && offer.status==="active"
                && (offer.fulfillmentMethod==="open" || offer.fulfillmentMethod==="fixed")
                && !selectedPlacement?.excludedOffers?.includes(offer._id)
            ) {
                selectedOffers.push(offer);
                adStats += 0;

                let offerAdBias = 0.0001;
                // eslint-disable-next-line no-restricted-syntax,no-loop-func
                ads[offer._id].forEach((ad)=>{
                    if(ad.status==="on" || ad.status==="fixed"){
                        adStats += 1
                        offerAdBias += ad.bias >=0? ad.bias : 1;
                    }
                })

                // eslint-disable-next-line no-restricted-syntax,no-loop-func
                ads[offer._id].forEach((ad)=>{
                    if(ad.status==="on" || ad.status==="fixed"){
                        adStats += 1
                        ad.percent = 100.0* (( ad.bias >=0? ad.bias : 1)/offerAdBias);
                    }
                })

                matchedOffers += 1;
            }
        }

        let offerBias = 0.0001;
        // eslint-disable-next-line no-restricted-syntax,no-loop-func
        selectedOffers.forEach((ad)=>{
           offerBias +=  ad.bias >=0? ad.bias : 1;
        });
        // eslint-disable-next-line no-restricted-syntax,no-loop-func
        selectedOffers.forEach((ad)=>{
            ad.percent = 100.0* (( ad.bias >=0? ad.bias : 1)/offerBias);
        });
    }


    return <Page title="General: Placements">
        {loadingLists ? <LoadingBackdrop/> :

            <Container maxWidth={themeStretch ? false : 'xl'}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>

                        <Card>
                            <CardHeader title={[
                                <Typography key={"h1K"} variant="title">Placements</Typography>,
                                <Button key={"h1B"} size="Large" align="right" variant="contained"
                                        startIcon={<Iconify icon={'eva:edit-2-fill'}/>} color="success"
                                        style={{"float": "right"}}
                                        onClick={() => {
                                            setSelectedPlacement({
                                                edit: false,
                                                name: "",
                                                type: "any",
                                                advertisers: ["any"],
                                                offers: ["any"]
                                            })
                                        }}>
                                    Create New
                                </Button>
                            ]} sx={{mb: 3}}/>

                            <div style={{height: Math.max(parseInt(window.innerHeight * .65, 10), 400), width: '100%'}}>
                                <DataGrid
                                    rows={lists}
                                    columns={columns}
                                    pageSize={50}
                                    rowsPerPageOptions={[50]}
                                />
                            </div>
                            <Divider/>

                            <Modal
                                open={Boolean(selectedPlacement)}
                                style={{"overflowY": "scroll"}}
                            >
                                <Box sx={{...modalStyle}}>
                                    {selectedPlacement &&
                                    <div>
                                        {/* [# Of Offers/Ads that will server]
                                                    Name, Type, Ad Type [Drop Down], Exclude Partners / Include Partners, Multiselect Offer
                                                */}
                                        <br/>
                                        {selectedPlacement.id && <Typography>Placement Id: {selectedPlacement.id}</Typography>}
                                        <Typography>
                                            Name:
                                            <FormControl fullWidth sx={{m: 1}}>
                                                <TextField
                                                    id="placement-name"
                                                    label="Placement Name"
                                                    autoComplete="off"
                                                    error={(selectedPlacement.name || '').length < 2}
                                                    color={(selectedPlacement.name || '').length >= 3 ? 'success' : 'error'}
                                                    value={selectedPlacement.name || ''}
                                                    placeholder={"Enter Name For Placement"}
                                                    onChange={(v) => {
                                                        setSelectedPlacement({
                                                            ...selectedPlacement,
                                                            name: v.target.value
                                                        });
                                                    }}
                                                />
                                            </FormControl>
                                        </Typography>
                                        <br/><br/>
                                        <InputLabel id="status">Status</InputLabel>
                                        <Select
                                            labelId="type-label"
                                            id="status"
                                            value={selectedPlacement.status}
                                            label="status"
                                            disabled={selectedPlacement.edit}
                                            onChange={(e) => {
                                                const z = {...selectedPlacement, status: e.target.value};
                                                setSelectedPlacement(z)
                                            }}
                                        >
                                            <MenuItem value={"on"}>ON</MenuItem>
                                            <MenuItem value={"off"}>OFF</MenuItem>
                                        </Select>
                                        <br/><br/>
                                        <InputLabel id="type-label">Ad Type</InputLabel>
                                        <Select
                                            labelId="type-label"
                                            id="type"
                                            value={selectedPlacement.type ? selectedPlacement.type : 'any'}
                                            label="Ad Type"
                                            disabled={selectedPlacement.edit}
                                            onChange={(e) => {
                                                const z = {...selectedPlacement, type: e.target.value};
                                                setSelectedPlacement(z)
                                            }}
                                        >
                                            <MenuItem value={"CPC"}>CPC</MenuItem>
                                            <MenuItem value={"CPA"}>CPA</MenuItem>
                                            <MenuItem value={"IR"}>IR</MenuItem>
                                            <MenuItem value={"any"}>ANY</MenuItem>
                                        </Select>
                                        <br/><br/>
                                        <FormControl sx={{m: 1, width: 300}}>
                                            <InputLabel id="advertiser-selector">Advertisers</InputLabel>
                                            <Select
                                                labelId="advertiser-selector-label"
                                                id="advertiser-selector-chip"
                                                multiple
                                                value={selectedPlacement.advertisers}
                                                onChange={(event) => {
                                                    const {
                                                        target: {value},
                                                    } = event;
                                                    console.log("Set ADvertiser");
                                                    const lst = typeof value === 'string' ? value.split(',') : value;
                                                    if (lst.indexOf("any") === lst.length - 1) {
                                                        setSelectedPlacement({
                                                            ...selectedPlacement,
                                                            advertisers: ["any"]
                                                        });
                                                        return;
                                                    }
                                                    if (lst.indexOf("any") !== -1) {
                                                        lst.splice(lst.indexOf("any"), 1);

                                                    }
                                                    setSelectedPlacement({
                                                        ...selectedPlacement,
                                                        advertisers: lst
                                                    });
                                                }}
                                                input={<OutlinedInput id="select-multiple-chip" label="Chip"/>}
                                                renderValue={(selected) => (
                                                    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                                                        {selected.map((value) => (
                                                            <Chip key={value} label={value}/>
                                                        ))}
                                                    </Box>
                                                )}
                                                MenuProps={MenuProps}
                                            >
                                                <MenuItem
                                                    key={"any"}
                                                    value={"any"}
                                                    style={{fontWeight: theme.typography.fontWeightRegular}}
                                                    onClick={() => {
                                                        setSelectedPlacement({
                                                            ...selectedPlacement,
                                                            advertisers: ["any"]
                                                        });
                                                    }}
                                                >
                                                    Any Advertiser
                                                </MenuItem>
                                                { Array.from(relevantAdvertiserOptions).map((name) => (
                                                    <MenuItem
                                                        key={name}
                                                        value={name}
                                                        style={{fontWeight: theme.typography.fontWeightRegular}}
                                                    >
                                                        {name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <br/><br/>
                                        <FormControl sx={{m: 1, width: "100%", maxHeight: 150, overflow: 'auto' }}>
                                            <InputLabel id="advertiser-selector">Offers</InputLabel>
                                            <Select
                                                labelId="advertiser-selector-label"
                                                id="advertiser-selector-chip"
                                                multiple
                                                value={selectedPlacement.offers}
                                                onChange={(event) => {
                                                    const {
                                                        target: {value},
                                                    } = event;
                                                    const lst = typeof value === 'string' ? value.split(',') : value;
                                                    if (lst.indexOf("any") === lst.length - 1) {
                                                        setSelectedPlacement({
                                                            ...selectedPlacement,
                                                            offers: ["any"]
                                                        });
                                                        return;
                                                    }
                                                    if (lst.indexOf("any") !== -1) {
                                                        lst.splice(lst.indexOf("any"), 1);

                                                    }
                                                    setSelectedPlacement({
                                                        ...selectedPlacement,
                                                        offers: lst
                                                    });
                                                }}
                                                input={<OutlinedInput id="select-multiple-chip" label="Chip"/>}
                                                renderValue={(selected) => (
                                                    <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                                                        {selected.map((value) => (
                                                            offerMap[value] && <Chip key={value} label={`${value==='any'?'any':offerMap[value]?.name}`}/>
                                                        ))}
                                                    </Box>
                                                )}
                                                MenuProps={MenuProps}
                                            >
                                                <MenuItem
                                                    key={"any"}
                                                    value={"any"}
                                                    style={{fontWeight: theme.typography.fontWeightRegular}}
                                                    onClick={() => {
                                                        setSelectedPlacement({
                                                            ...selectedPlacement,
                                                            offers: ["any"]
                                                        });
                                                    }}
                                                >
                                                    Any Offer
                                                </MenuItem>
                                                {relevantOfferOptions.map((o) => (
                                                    <MenuItem
                                                        key={o.id}
                                                        value={o.id}
                                                        style={{fontWeight: theme.typography.fontWeightRegular}}
                                                    >
                                                        {o.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
    <FormControl sx={{m: 1, width: "100%", maxHeight: 150, overflow: "auto" }}>
    <InputLabel id="excluded-offers-selector">Excluded Offers</InputLabel>
     <Select
        labelId="excluded-offers-selector-label"
        id="excluded-offers-selector-chip"
        multiple
        value={selectedPlacement.excludedOffers || []}
        onChange={(event) => {
            const { target: { value } } = event;
            const lst = typeof value === 'string' ? value.split(',') : value;
            if (lst.includes("none")) {
                setSelectedPlacement({
                    ...selectedPlacement,
                    excludedOffers: []
                });
            } else {
                setSelectedPlacement({
                    ...selectedPlacement,
                    excludedOffers: lst
                });
            }
        }}
        input={<OutlinedInput id="select-multiple-chip" label="Chip"/>}
        renderValue={(selected) => (
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                {selected.map((value) => (
                    offerMap[value] && <Chip key={value} label={`${offerMap[value]?.name}`}/>
                ))}
            </Box>
        )}
        MenuProps={MenuProps}
    >
             <MenuItem
            key="none"
            value="none"
            style={{fontWeight: theme.typography.fontWeightRegular}}
        >
            None
        </MenuItem>
        {relevantOfferOptions.map((o) => (
            <MenuItem
                key={o.id}
                value={o.id}
                style={{fontWeight: theme.typography.fontWeightRegular}}
            >
                {o.name}
            </MenuItem>
        ))}
    </Select>
</FormControl>
                                        <br/><br/>
                                        <Typography>
                                            There are active {matchedOffers.toLocaleString()} Offers
                                            and {adStats.toLocaleString()} servable Ads that qualify for this
                                            placement. <br/>
                                            Click to see full <Button onClick={()=>{setOfferBreakdown(true)}}>breakdown </Button> <br/>
                                            For Full Performance Break Down <Link href={"#"}>Go Here</Link>
                                        </Typography>
                                        <br/>
                                        <ButtonGroup disableElevation variant="contained" style={{"width": "100%"}}>
                                            <Button size="Large" align="right" variant="contained" color="success"
                                                    onClick={() => {
        user.getIdToken().then((idToken) => {

            if (selectedPlacement.id) {
                axios.put(`${BASE_HOST}/api/basic/placements`, selectedPlacement, getAccountAPIHeader(idToken))
                  .then((out) => {
                      window.location.reload()
                  });
            } else {
                axios.post(`${BASE_HOST}/api/basic/placements`, selectedPlacement, getAccountAPIHeader(idToken))
                  .then((out) => {
                      window.location.reload()
                  });
            }

        })
                                                    }} style={{"width": "100%"}}
                                                    disabled={selectedPlacement.name.length <= 3}>
                                                Save
                                            </Button>
                                            <Button size="Large" align="right" variant="contained" color="warning"
                                                    onClick={() => {
                                                        setSelectedPlacement(null);
                                                    }} style={{"width": "100%"}}>
                                                Close
                                            </Button>
                                        </ButtonGroup>

                                    </div>}
                                    <div/>

                                </Box>
                            </Modal>

                        <Modal
                            open={offersBreakdown}
                            onClose={() => setOfferBreakdown(false)}
                            style={{"overflowY": "scroll"}}
                        >
                            <Box sx={{...modalStyle, "maxHeight": "90%", "overflow":"scroll"}}>
                                <div>
                                    {selectedOffers.map(
                                        (value) =>
                                        <div>
                                            <Link href={`/dashboard/offer?id=${value._id}`}>|{value.percent.toFixed(1)}%| {value.name}</Link>
                                            {ads[value._id].map((ad) => <>
                                                {ad.status==="on" || ad.status==="fixed"? <li><Link href={`/dashboard/createAd?id=${ad._id}`}>|{ad.percent.toFixed(1)}%| {ad.name} [{ad.availability}]</Link></li> : <></>}
                                                </>)}
                                            <br/>

                                        </div>
                                    )}
                                </div>
                                <br/>
                            </Box>
                        </Modal>

                        </Card>


                    </Grid>
                </Grid>
            </Container>
        }

    </Page>;
}